import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, IconButton, Chip, Stack, Typography } from '@mui/material';
import { ArrowBack, Wifi, WifiOff } from '@mui/icons-material';

interface BillingPanelHeaderProps {
  connected: boolean;
}

const BillingPanelHeader: React.FC<BillingPanelHeaderProps> = ({ connected }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 2 }}>
      {/* Linha de navegação e status */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <IconButton
          onClick={() => navigate(-1)}
          color="inherit"
          sx={{ color: 'black', ml: { xs: -1, sm: 0 } }}
        >
          <ArrowBack />
        </IconButton>




        <Chip
          icon={connected ? <Wifi /> : <WifiOff />}

          label={connected ? 'Conectado' : 'Desconectado'}
          color={connected ? 'success' : 'default'}
          sx={{ fontWeight: 'bold' }}
        />
      </Box>


      {/* Logo e título centralizado */}
      <Box sx={{ textAlign: 'center', mt: 1 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 1 }}
        >
          <Box
            component="img"
            src="/images/logo_nimo_energia_quadrada.png"
            alt="Nimo Energia"
            sx={{ height: { xs: 45, sm: 55 }, objectFit: 'contain' }}
          />
        </Stack>
        <Typography variant="h4" fontWeight="bold" fontSize={{ xs: 24, sm: 28 }} gutterBottom>
          Painel de Faturamento
        </Typography>
        <Typography variant="h6" color="text.secondary" fontSize={{ xs: 16, sm: 20 }}>
          Acompanhe a fila de motoristas e o histórico de atendimentos
        </Typography>
      </Box>
    </Box>
  );
};

export default BillingPanelHeader;


